<template>
  <div class="accountSetting pl-xl-4">
    <loader v-show="pageLoader"></loader>
    <!-- Merchant Keys -->
    <div
      v-if="get_user.lead_type == 1"
      class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-1"
    >
      <h5 class="medium">Merchant Keys</h5>
      <div class="flex-shrink-0 flex-none">
        <div v-if="apiKeyResponse.length">
          <a
            href="javascript:void(0)"
            class="cap_btn-b secondary"
            @click="() => openModal('gauthModal', 'disable', true)"
            >Disable</a
          >
          <a
            href="javascript:void(0)"
            class="cap_btn-b secondary"
            @click="() => openModal('gauthModal', 'update', true)"
            >Update</a
          >
        </div>
        <div v-else>
          <a
            v-if="get_user.verified_status"
            href="javascript:void(0)"
            class="cap_btn-b secondary d-block"
            @click="() => openModal('gauthModal', 'view', true)"
            >View</a
          >
        </div>
      </div>
    </div>
    <div
      v-if="get_user.lead_type == 1"
      class="card-body mobAPi border-bottom pb-4 mb-4"
    >
      <div v-if="error" class="mt-1 alert alert-danger">{{ error }}</div>
      <div v-if="get_user.verified_status" class="">
        <div class="walletBlock position-relative mb-4">
          <label class="mb-2">API Key</label>
          <div class="bg-white border position-relative copyCode">
            <div class="copied" v-if="msgCopied"><span>Copied</span></div>
            <p class="mb-0">
              {{
                apiKeyResponse.length ? apiKeyResponse[0].apiKey : "********"
              }}
            </p>
            <a
              v-if="apiKeyResponse.length"
              href="javascript:void(0)"
              v-clipboard:copy="
                apiKeyResponse.length ? apiKeyResponse[0].apiKey : '********'
              "
              v-clipboard:success="() => onCopy(false)"
              class="copyBtn position-absolute"
            >
              <feather type="copy"></feather>
            </a>
          </div>
        </div>
        <div class="walletBlock position-relative mb-4">
          <label class="mb-2">Secret Key</label>
          <div class="bg-white border position-relative copyCode">
            <div class="copied" v-if="msgCopied1"><span>Copied</span></div>
            <p class="mb-0">
              {{
                apiKeyResponse.length
                  ? apiKeyResponse[0].clientSecretKey
                  : "********"
              }}
            </p>
            <a
              v-if="apiKeyResponse.length"
              v-clipboard:copy="
                apiKeyResponse.length
                  ? apiKeyResponse[0].clientSecretKey
                  : '********'
              "
              v-clipboard:success="() => onCopy(true)"
              href="javascript:void(0)"
              class="copyBtn position-absolute"
            >
              <feather type="copy"></feather>
            </a>
          </div>
        </div>
      </div>
      <div v-else class="d-flex align-items-start">
        <span class="iconSave"
          ><img
            src="../../../../../static/website/images/info.svg"
            alt="Phone"
            title="Phone Numbers"
        /></span>
        <div class="flex-shrink-0 ml-3">
          <h5 class="medium mb-2">Not verified</h5>
          <p class="mt-1 mb-0">
            Your keys will be automatically generated once admin has approved
            your documents
          </p>
        </div>
      </div>
    </div>
    <!-- Social Trading Keys -->
    <!-- <div
      class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-1"
      :class="{ 'mt-2': get_user.lead_type }"
    >
      <h5 class="medium">Social Trading Keys</h5>
      <div class="flex-shrink-0 flex-none" v-if="get_user.social_user == 3">
        <div v-if="apiKeyResponse.length">
          <a
            href="javascript:void(0)"
            class="cap_btn-b secondary"
            @click="() => openModal('gauthModal', 'disable')"
            >Disable</a
          >
          <a
            href="javascript:void(0)"
            class="cap_btn-b secondary"
            @click="() => openModal('gauthModal', 'update')"
            >Update</a
          >
        </div>
        <div v-else>
          <a
            href="javascript:void(0)"
            class="cap_btn-b secondary d-block"
            @click="() => openModal('gauthModal', 'view')"
            >View</a
          >
        </div>
      </div>
      <div v-else>
        <router-link to="/social-trading" class="cap_btn-b secondary">
          + Create
        </router-link>
      </div>
    </div> -->
    <div class="card-body mobAPi border-bottom pb-4 mb-4">
      <!-- <div v-if="error" class="mt-1 alert alert-danger">{{ error }}</div> -->
      <div v-if="get_user.social_user == 3" class="">
        <div class="walletBlock position-relative mb-4">
          <label class="mb-2">API Key</label>
          <div class="bg-white border position-relative copyCode">
            <div class="copied" v-if="msgCopied"><span>Copied</span></div>
            <p class="mb-0">
              {{
                apiKeyResponse.length ? apiKeyResponse[0].apiKey : "********"
              }}
            </p>
            <a
              v-if="apiKeyResponse.length"
              href="javascript:void(0)"
              v-clipboard:copy="
                apiKeyResponse.length ? apiKeyResponse[0].apiKey : '********'
              "
              v-clipboard:success="() => onCopy(false)"
              class="copyBtn position-absolute"
            >
              <feather type="copy"></feather>
            </a>
          </div>
        </div>
        <div class="walletBlock position-relative mb-4">
          <label class="mb-2">Secret Key</label>
          <div class="bg-white border position-relative copyCode">
            <div class="copied" v-if="msgCopied1"><span>Copied</span></div>
            <p class="mb-0">
              {{
                apiKeyResponse.length
                  ? apiKeyResponse[0].clientSecretKey
                  : "********"
              }}
            </p>
            <a
              v-if="apiKeyResponse.length"
              v-clipboard:copy="
                apiKeyResponse.length
                  ? apiKeyResponse[0].clientSecretKey
                  : '********'
              "
              v-clipboard:success="() => onCopy(true)"
              href="javascript:void(0)"
              class="copyBtn position-absolute"
            >
              <feather type="copy"></feather>
            </a>
          </div>
        </div>
      </div>
      <div v-else class="d-flex align-items-start">
        <span class="iconSave"
          ><img
            src="../../../../../static/website/images/info.svg"
            alt="Phone"
            title="Phone Numbers"
        /></span>
        <div class="flex-shrink-0 ml-3">
          <h5 class="medium mb-2">You haven't created any API keys yet</h5>
          <p class="mt-1 mb-0">
            API keys allow you to perform automated actions on your account with
            your own software.<a href="javascript:void(0)"> Learn More</a>
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="border-bottom d-flex align-items-center justify-content-between py-3 my-3" > <h5 class="medium">My OAuth2 Applications</h5> <a href="javascript:void(0)" class="cap_btn-b secondary" >+ New OAuth2 Application</a > </div>--><!-- <div class="card-body border-bottom pb-4 mb-4"> <div class="d-flex align-items-start"> <span class="iconSave" ><img src="../../../../../static/website/images/info.svg" alt="Phone" title="Phone Numbers"/></span> <div class="flex-shrink-0 ml-3"> <h5 class="medium mb-2"> You haven't created any OAuth2 Applications yet </h5> <p class="mt-1 mb-0"> ABuild applications for others using the Capital Wallet API. <a href="javascript:void(0)"> Learn More</a> </p></div></div></div>--><!-- <div class="border-bottom py-3 my-3"> <h5 class="medium">API Version and Notifications</h5> </div>--><!-- <div class="apiVersion d-flex align-items-center"> <p class="mb-0 mr-3">API Version: 2022-01-01</p><p class="status mb-0 lightgrayBG">You're up-to-date</p></div>--><!-- <div class="buttons d-flex align-items-center justify-content-end mt-4"> <a href="javascript:void(0)" class="cap_btn-b mr-3 min-auto">Cancel</a> <a href="javascript:void(0)" class="cap_btn small">Save</a> </div>-->
    <div
      class="modal fade"
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close text-right pr-2"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body text-center">
            <img
              src="../../../../../static/website/images/getAPI.svg"
              alt="API"
              title="API"
            />
            <h5 class="my-4">To get started with new API, Create a new key</h5>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Enter API key label"
                name=""
              />
            </div>
            <a
              data-dismiss="modal"
              data-toggle="modal"
              id="forgotPassword"
              data-target="#exampleModalCenter1"
              href="javascript:void(0)"
              class="cap_btn lg mt-3"
              >Create New Key</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModalCenter1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close text-right pr-2"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body text-center">
            <img
              src="../../../../../static/website/images/authenticator.png"
              alt="API"
              title="API"
            />
            <h5 class="my-4">Google Authentication Code</h5>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Enter 2fa Code"
                name=""
              />
            </div>
            <a
              data-dismiss="modal"
              data-toggle="modal"
              data-target="#exampleModalCenter2"
              href="javascript:void(0)"
              class="cap_btn lg mt-3"
              >Submit</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModalCenter2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close text-right pr-2"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body text-center">
            <feather
              size="40px"
              class="successfully"
              type="check-circle"
            ></feather>
            <h5 class="my-4">API Key Created Successfully</h5>
            <p>
              We have sent a confirmation email to you. Please follow the
              instructions in the email to create your new key.
            </p>
            <div class="text-left border-top pt-3 mt-3">
              <p class="mb-2">
                If you haven't received the email, please try the following:
              </p>
              <ul class="list-circle">
                <li>Check your spam or junk mail folders.</li>
                <li>
                  Add Capitalwallet to your email whitelist.
                  <a href="javascript:void(0)" class="secondary"
                    >How can I do this?</a
                  >
                </li>
                <li>Make sure your email client is functioning normally.</li>
              </ul>
            </div>
            <a
              href="javascript:void(0)"
              class="cap_btn lg mt-3"
              data-dismiss="modal"
              >Okay</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="gauthModal"
      role="dialog"
      aria-labelledby="gauthModalTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            @click="() => closeModal('gauthModal')"
            type="button"
            class="close text-right pr-2"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body text-center w-100">
            <img
              src="../../../../../static/website/images/authenticator.png"
              alt="authenticator"
              title="Google Authenticator"
            />
            <h5 class="my-4">Google Authentication Code</h5>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="******"
                name=""
                v-model="gauth"
              />
            </div>
            <a
              v-if="modalType == 'view'"
              @click="() => getApiKeys()"
              href="javascript:void(0)"
              class="cap_btn lg mt-3"
              >Get Keys</a
            >
            <a
              v-if="modalType == 'disable'"
              @click="() => disableApiKeys()"
              href="javascript:void(0)"
              class="cap_btn lg mt-3"
              >Disable Keys</a
            >
            <a
              v-if="modalType == 'update'"
              @click="() => updateApiKeys()"
              href="javascript:void(0)"
              class="cap_btn lg mt-3"
              >Update Keys</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { registerStepsMixins } from "@/plugins/registerSteps";
import tradingMixins from "@/plugins/trading";

export default {
  name: "accountprofile",
  mixins: [registerStepsMixins, tradingMixins],
  data() {
    return {
      notification_msg: "",
      notification_type: "",
      pageLoader: false,
      msgCopied: false,
      msgCopied1: false,
      // tab: '1',
      submitted: false,
      // editAddress: false,
      // editNumber: false,

      fname: "",
      apiKeyResponse: [],
      modalType: null,
      mName: "",
      lname: "",
      dob: "",
      gauth: "",
      address: "",
      city: "",
      state: "",
      country: "",
      area_code: "",
      acc_type: "",
      merchantKeys: false,
      OrganizationType: {
        0: "Company",
        1: "Self Managed Super Fund",
        2: "Discretionary/Unit Trust",
        3: "Others",
      },
      error: null,
    };
  },
  components: {
    // editAddress,
    // editNumber
  },

  methods: {
    create_image(url, name) {
      var stx = this.stxx;
      var link = document.createElement("a");
      link.download = name;
      link.href = url;
      link.click();
    },
    ChangeTab(val) {
      this.tab = val;
      // this.editAddress = false
      // this.editNumber = false
      this.pageLoader = false;
    },
    Submit() {
      const _that = this;
      _that.submitted = true;
      _that.$validator.validate().then((valid) => {
        if (valid) {
          let input_json = {
            globalParams: {
              f_name: _that.fname,
              m_name: _that.mName,
              l_name: _that.lname,
              dob: _that.dob,
              Address: _that.address,
              City: _that.city,
              State: _that.state,
              Country: _that.country,
              Areacode: _that.area_code,
              Acc_type: _that.acc_type,
            },
            localParams: {
              parameter: _that,
            },
          };
        }
      });
    },
    onCopy(isClientSecret) {
      if (isClientSecret) {
        this.msgCopied1 = true;
        setTimeout(() => {
          this.msgCopied1 = false;
        }, 3000);
      } else {
        this.msgCopied = true;
        setTimeout(() => {
          this.msgCopied = false;
        }, 3000);
      }
    },
    openModal(id, type, isMerchant) {
      if (isMerchant) {
        this.merchantKeys = true;
      } else {
        this.merchantKeys = true;
      }
      this.error = null;
      this.modalType = type;
      let modal = document.getElementById(id);
      modal.classList.add("show");
    },
    closeModal(id) {
      this.modalType = null;
      let modal = document.getElementById(id);
      modal.classList.remove("show");
    },
    getApiKeys() {
      let obj = {
        globalParams: {
          otp: this.gauth,
          type: "KEYS",
          key_type: this.merchantKeys
            ? "3"
            : this.user_type == "FOLLOWER"
            ? "1"
            : "2",
        },
        localParams: {
          parameter: this,
        },
      };
      this._runGetApiKey(obj);
    },
    updateApiKeys() {
      let obj = {
        globalParams: {
          otp: this.gauth,
          type: "KEYS",
          id: this.apiKeyResponse.length ? `${this.apiKeyResponse[0].id}` : `0`,
          key_type: this.merchantKeys
            ? "3"
            : this.user_type == "FOLLOWER"
            ? "1"
            : "2",
        },
        localParams: {
          parameter: this,
        },
      };
      this._runUpdateApiKey(obj);
    },
    disableApiKeys() {
      let obj = {
        globalParams: {
          otp: this.gauth,
          id: this.apiKeyResponse.length ? `${this.apiKeyResponse[0].id}` : `0`,
          key_type: this.merchantKeys
            ? "3"
            : this.user_type == "FOLLOWER"
            ? "1"
            : "2",
        },
        localParams: {
          parameter: this,
        },
      };
      this._runDisableApiKey(obj);
    },
  },
  created() {
    this.pageName("Account Profile");
    // this._runGetProfileInfo({
    //   globalParams: {},
    //   localParams: {
    //     parameter: this,
    //   },
    // });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/api.vue